const BaseOrganic = require('./common/base-organic');
const jQuery = require('../vendor/jquery-3.5.1.min');
window.jQuery = jQuery;
const VendorsSearch = require('./components/vendors-search');
const WriteReview = require('./components/write-review');
const StarsRatingAndFeedback = require('./components/stars-rating-and-feedback');

const $ = window.jQuery;

const SubmitReview = {
  init() {
    if ($("#review-vendor").length > 0 && typeof VendorsSearch !== "undefined") {
      VendorsSearch.init({
        inputSelector: '#review-vendor',
        autoSelect: true,
        companyIdInpSelector: '#vendor_id'
      });
    }

    WriteReview.init();
  },
};

$(function () {
  BaseOrganic.init();
  SubmitReview.init();
  StarsRatingAndFeedback.init();
});
